import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  discussionsTitle: {
    id: 'discussions.sidebar.title',
    defaultMessage: 'Discussions',
    description: 'Title text for a forum where users are able to discuss course topics',
  },
  openDiscussionsTrigger: {
    id: 'discussions.sidebar.open.button',
    defaultMessage: 'Show discussions tray',
    description: 'Alt text for a button that opens the discussions feature',
  },
});

export default messages;
